<template>
  <Cfg>
    <slot>
      <div class="animated fadeIn">
        <Alerts ref="alert"/>
        <Forms ref="frmGroup"
          :title="this.$lang.SchedulingType.TitleForm"
          :showHelp="true"
          :showClearButton="true"
          :showSaveButton="true"
          v-on:Clear="onClear"
          v-on:Save="onSave">
          <div class="form-group row">
            <div class="col-md-12">
              <label for="cbxSinisterSchedulingType"><small class="text-danger">*</small> {{$lang.SchedulingType.LabelArea}}:</label>
              <div class="input-group">
                <b-form-select v-model="form.areaID.value"
                              :options="form.areaID.options"
                              :state="form.areaID.state"
                              class="mb-3" >
                   <template slot="first">
                    <!-- this slot appears above the options from 'options' prop -->
                    <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
                  </template>
                </b-form-select>
              </div>
            </div>

          </div>
          <div class="form-group row">
            <div class="col-md-6">
              <label for="txtName"><small class="text-danger">*</small> {{$lang.SchedulingType.LabelName}}:</label>
              <div class="input-group">
                <b-form-input type="text"
                              :placeholder="$lang.SchedulingType.PlaceholderEnterName"
                              v-model="form.name.value"
                              :size="form.name.maxlength"
                              :required="form.name.required"
                              :state="form.name.state"></b-form-input>
              </div>
            </div>
            <div class="col-md-6">
              <label for="txtCNPJ"><small class="text-danger">*</small> {{$lang.SchedulingType.LabelMnemonic}}:</label>
              <div class="input-group">
                <b-form-input type="text"
                              :placeholder="$lang.SchedulingType.PlaceholderEnterMnemonic"
                              v-model="form.mnemonic.value"
                              :size="form.mnemonic.maxlength"
                              :required="form.mnemonic.required"
                              :state="form.mnemonic.state"></b-form-input>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-md-12">
              <label for="txtDescription"> {{$lang.SchedulingType.LabelDescription}}:</label>
              <b-form-textarea id="txtDescription"
                          name="txtDescription"
                          v-model="form.description.value"
                          :placeholder="$lang.SchedulingType.PlaceholderEnterDescription"
                          :rows="form.description.rows"
                          :size="form.description.maxlength"
                          :noResize="form.description.noResize"></b-form-textarea>
              <small class="small-help"><i class="fa fa-info-circle"></i> <span v-html="FieldSizeTip"></span>.</small>
            </div>
          </div>
        </Forms>

        <Tables ref="tableGrid"
            :columns="[$lang.SchedulingType.DataTable.Name,
                       $lang.SchedulingType.DataTable.Area,
                       $lang.Common.DataTable.Status,
                       $lang.Common.DataTable.ActionDate,
                       $lang.Common.DataTable.AccountAction,
                       $lang.Common.DataTable.Actions]"
            :showSearch="false"
            :showPrint="true"
            :showDownload="false"
            :showFullscreen="false"
            v-on:Load="onLoad">
          <tr v-for="obj in this.objList" v-bind:key="obj.id">
            <TableColumn :IsText="true"     v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.name" />
            <TableColumn :IsText="true"     v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.area.name" />
            <TableColumn :IsStatus="true"   v-on:Edit="onEdit(obj)" :status="obj.status" />
            <TableColumn :IsDatetime="true" v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.dateUpdate" />
            <TableColumn :IsText="true"     v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.accountUserNameUpdate" />
            <TableColumn :IsActionsButtons="true" v-on:Change="onChange(obj)" v-on:Delete="onDelete(obj)" :status="obj.status" />
          </tr>
        </Tables>
      </div>
    </slot>
  </Cfg>
</template>

<script>
import SchedulingType from './schedulingtype.js'

export default SchedulingType
</script>



// WEBPACK FOOTER //
// src/views/private/configuration/schedulingtype/schedulingtype.vue